function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 35"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.698.02L26.406.355a67.12 67.12 0 00-.083 8.16 2.59 2.59 0 011.08-.833c.11 0 .166.055.166.166-.43.153-.762.43-.997.833-.202.201-.396.201-.581 0a73.49 73.49 0 01.083-8.493c3.873-.166 7.748-.222 11.624-.166z",
  fill: "#545454"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.374 3.35v1h-1.826v2.165h-1.163V4.516a5.11 5.11 0 00-1.826-.166v-1h1.826V1.354h1.163V3.35h1.826z",
  fill: "#545454"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.563 3.35v1a5.11 5.11 0 011.827.166h-1.993c-.05-.426.005-.814.166-1.165z",
  fill: "#878F99"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.377 3.35c.161.352.217.74.166 1.166h-1.826c.053.7-.003 1.366-.166 1.998V4.35h1.826v-1z",
  fill: "#9198A2"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.288 8.68H2.661c-.055 7.577 0 15.125.166 22.646h34.208c.166-7.52.22-15.07.166-22.646-3.35.055-6.672-.001-9.964-.167a.55.55 0 01.332-.25l10.296-.166a.74.74 0 00.332-.25c.035-.974.34-1.14.913-.5.111 8.382.111 16.763 0 25.145-.312.732-5.23.562-5.883.395 2.076.333 2.242-.333.083-.916 2.325.75.925.91.57 1.02-9.153.331-18.342.443-27.566.333.028-.165-.027-.276-.166-.333-.384-.11.956.338.51.337-.881.01-3.467-.327-4.246-.004-.795.178-1.349-.1-1.661-.832a939.26 939.26 0 010-24.978c.138-.36.387-.61.747-.75 3.985-.083 7.97-.11 11.956-.083a9.173 9.173 0 00-.166 1.999z",
  fill: "#545454"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.698.02a.375.375 0 01.25.167c.11 2.442.11 4.885 0 7.327l-.25.25c-3.376.083-6.752.11-10.13.083 0-.111-.055-.167-.165-.167a159.25 159.25 0 0110.295-.166V.354H26.406L37.698.02z",
  fill: "#545454"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.289 8.679a164.41 164.41 0 01-10.462.166v22.48c-.166-7.52-.22-15.07-.166-22.646H13.29z",
  fill: "#9FA6AE"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.236 8.514c3.293.166 6.614.221 9.964.166.055 7.577 0 15.126-.166 22.647V8.847c-3.323.055-6.644 0-9.964-.167.02-.1.076-.156.166-.166z",
  fill: "#BABFC6"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.596 1.852a5.848 5.848 0 013.322.75 26.368 26.368 0 012.573 2.414c.906 1.669 1.155 3.445.748 5.329.53.002.807.28.83.832-.23.98-.534 1.924-.913 2.831a.957.957 0 01-.914.333 4.278 4.278 0 01-.58 1.665c.03.983.335 1.9.913 2.748.628.33 1.265.634 1.91.916a6.97 6.97 0 01.082 3.33c-1.38.189-2.294.966-2.74 2.331a15.049 15.049 0 00-.83 5.329l.249.25a894.88 894.88 0 01-17.27.083c-1.176-5.302.706-8.966 5.646-10.99.185 1.496.268 2.995.25 4.496-.843 1.056-.76 2.027.248 2.914 1.896.21 2.588-.596 2.076-2.415a2.533 2.533 0 00-1.495-.832 34.578 34.578 0 01-.249-2.748 3.668 3.668 0 01.332-1.748c.63-.289 1.24-.622 1.827-1a8.649 8.649 0 00.83-2.164 232.99 232.99 0 00-.664-1.998 9.039 9.039 0 00-.747-.333 9.878 9.878 0 01-.996-3.33c.097-.394.346-.56.747-.5-.028-1.39 0-2.777.083-4.163.72-2.417 2.298-3.86 4.732-4.33z",
  fill: "#545454"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.097 29.66l-.332-2.331a50.418 50.418 0 00-.166-3.33v-1.332h-1.993v1.332a41.053 41.053 0 01-.249 5.828 286.119 286.119 0 00-3.155-10.49c-.125-.468-.07-.912.166-1.333.12-.158.258-.186.415-.083.921.84 1.862 1.645 2.823 2.414-.218.303-.467.58-.747.833.244.904.853 1.292 1.826 1.165l1.08-.166.83-1c-.485-.286-.79-.674-.913-1.165a22.325 22.325 0 002.823-2.331c.468.672.523 1.394.166 2.165-.943 3.252-1.801 6.527-2.574 9.824z",
  fill: "#F9FBFD"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.736 20.17c4.897 1.994 6.668 5.601 5.314 10.824H28.9c.18-1.994.207-3.992.083-5.995a3.445 3.445 0 00-1.744-1.998 2 2 0 00.166-1l.332-1.831zM27.73 20.169L27.4 22a6.161 6.161 0 01.166-1.998c.1.02.156.076.166.167zM20.594 24c-.16-.35-.216-.74-.166-1.166h-1.66c.05.427-.006.815-.166 1.166v-1.332h1.992V24z",
  fill: "#545454"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.906 23.832c.446-.027.889 0 1.328.084.36.25.664.555.914.915.304 1.993.332 3.992.083 5.995a7.71 7.71 0 00-2.491 0 12 12 0 00-2.076-.5c.061-1.972.504-3.86 1.328-5.661.288-.317.592-.594.914-.833zM12.626 25.331c.828.083.994.444.498 1.082-.85-.029-1.016-.39-.498-1.082zM20.762 27.33l.332 2.331c-.01.09-.065.146-.166.167a9.55 9.55 0 01-.166-2.498z",
  fill: "#545454"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.314 33.324c9.106.139 18.239.222 27.4.25-9.161.028-18.294.111-27.4.25-.22-.167-.22-.333 0-.5z",
  fill: "#FEFEFE"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.441 34.49c2.383-.055 4.763 0 7.14.167a.607.607 0 01-.165.25c-2.324.083-4.65.11-6.975.083v-.5z",
  fill: "#FBFBFB"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.332 34.656a.512.512 0 01.498.167c-.258.216-.424.16-.498-.167z",
  fill: "#F7F7F8"
})));